import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import classnames from 'classnames';
import React from 'react';
import './lifeline.scss';
export const Lifeline = (props)=>{
    const { children, className, onAction, ...spreadable } = props;
    const backMessageStyles = classnames(props, `cmx-lifeline`, 'qa-lifeline');
    console.log('here', window.history.length);
    const backAvailable = window.history.length > 1;
    const backUp = (event)=>{
        event.preventDefault();
        if (backAvailable) {
            window.history.back();
        } else {
            window.location.reload();
        }
        onAction();
    };
    return /*#__PURE__*/ _jsxs("div", {
        ...spreadable,
        className: classnames(backMessageStyles),
        children: [
            props.message,
            ' ',
            /*#__PURE__*/ _jsx("a", {
                href: "#back",
                className: "qa-action-link",
                onClick: backUp,
                children: backAvailable ? 'Go back' : 'Refresh'
            })
        ]
    });
};
